// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cadb8c3a","488":"b9bd0b39","977":"43b9c92f"}[chunkId] + ".chunk.js";
};